import React, { useCallback, useState } from 'react';

async function fetchStoreAvailabilities(stores, skus) {
  try {
    const response = await fetch('/wcs/resources/store/301/dynamicInventory/inStore', {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ stores, skus }),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch store availabilities');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching store availabilities:', error);
    throw error;
  }
}

export default function useStoreAvailabilities() {
  const [availabilities, setAvailabilities] = useState({});

  const fetchAvailabilities = useCallback(async (stores, skus) => {
    if (stores.length === 0 || skus.length === 0) {
      return;
    }

    return fetchStoreAvailabilities(
      stores.map((store) => store.externalId),
      skus
    ).then((data) => {
      setAvailabilities((availabilities) => {
        return data.response.skus.reduce(
          (acc, skuData) => {
            if (!skuData.sku) {
              return acc;
            }
            acc[skuData.sku] = skuData.stores.reduce((storeAcc, store) => {
              storeAcc[store.store] = store;
              return storeAcc;
            }, {});

            return acc;
          },
          { ...availabilities }
        );
      });
    });
  }, []);

  return { availabilities, fetchAvailabilities };
}
